<template>
  <div>
    <v-checkbox label="Assina CCB" v-model="assinaCCB" @change="retiraPapeis" v-if="!!nomeConjuge" />
    <input-multiselect v-model="model" :options="papeis" label="Papéis" :required="!nomeConjuge || assinaCCB" :disabled="!assinaCCB && !!nomeConjuge" />
  </div>
</template>
<script>
export default {
  props: {
    codigoProposta: String,
    value: [],
    assinante: Object,
    nomeConjuge: String,
    cliente: Object,
  },
  data () {
    return {
      proposta: null,
      listBase: [],
      assinaCCB: false
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    papeis: {
      get () {
        return this.$param.EST_PAPEIS.map(el => {
          return {
            text: el.papel.replace('@EMITENTENOME', this.cliente?.Nome).replace('@REPRESENTANTEDOCUMENTO', this.cliente?.DocumentoFederal).toUpperCase(),
            value: el.papel.replace('@EMITENTENOME', this.cliente?.Nome).replace('@REPRESENTANTEDOCUMENTO', this.cliente?.DocumentoFederal).toUpperCase(),
          }
        })
      },
      set () {
        return this.$param.EST_PAPEIS;
      }
    },
  },
  methods: {
    submit () {
      const th = this;
      const assinante = th.assinante
      if (!th.assinaCCB) {
        th.model = []
      }

      let arrayInclusao = [];
      let arrayExclusao = [];

      th.model.forEach(papel => {
        if (!th.listBase.map(({ Descricao }) => Descricao).includes(papel)) arrayInclusao.push(papel);
      });

      th.listBase.forEach(papel => {
        if (!th.model.includes(papel.Descricao)) arrayExclusao.push(papel)
      });

      if (arrayExclusao.length > 0) {
        arrayExclusao = arrayExclusao.map(papel => {
          return papel.Codigo
        })

        th.$api.Multiplo.Post('RemoveCCBDigitalAssinaturas', { dto: arrayExclusao }).then(resExclude => {
          if (th.$api.UI.PostLoadData(resExclude, true)) { };
        });
      }

      if (arrayInclusao.length > 0) {
        arrayInclusao = arrayInclusao.map(papel => {
          return {
            CodigoProposta: th.codigoProposta,
            Nome: th.nomeConjuge ? `${assinante.Nome} - CÔNJUGE DE ${th.nomeConjuge}` : assinante.Nome,
            Email: assinante.Email,
            Documento: assinante.DocumentoFederal,
            TelefoneCelular: assinante.TelefoneCelular,
            Descricao: papel
          }
        })

        th.$api.Multiplo.Post('InsertCCBDigitalAssinaturas', { dto: arrayInclusao }).then(resInsert => {
          if (th.$api.UI.PostLoadData(resInsert, true)) { };
        });
      }
    },
    carregarAssinantes (codigoProposta) {
      const th = this;
      const dtoAssinantes = {
        parameters: [
          { name: 'CodigoProposta', value: codigoProposta },
          { name: 'search', value: '' },
        ],
      };

      th.$api.Multiplo.Post('ListCCBDigitalAssinatura', dtoAssinantes).then(assinantes => {
        if (th.$api.UI.PostLoadData(assinantes)) {
          th.$set(th, 'listBase', assinantes.Data.filter(el => el.Documento === th.$api.UI.Format.SomenteAlfanumerico(th.assinante.DocumentoFederal)));
          th.$set(th, 'model', th.listBase.map(({ Descricao }) => Descricao));
          if (th.listBase.length > 0) th.assinaCCB = true;
        }
      });
    },
    retiraPapeis () {
      const th = this;
      if (!th.assinaCCB) {
        th.model = []
      } else {
        th.$set(th, 'model', th.listBase.map(({ Descricao }) => Descricao));
      }
    }
  },
}
</script>
<style scoped>
</style>
